import { BigNumber } from "ethers";
import React from "react";

export type AssetsContextValue = {
  balance?: BigNumber;
  formattedBalance?: string;
  honeyBalance?: BigNumber;
  readHoneyBalance: () => void;
  fancyBearsInWallet?: number[];
  fancyBearsInWalletCount?: number;
  readFancyBearsInWallet: () => void;
  honeyJarsInWallet?: number[];
  honeyJarsInWalletCount?: number;
  readHoneyJarsInWallet: () => void;
  traitsInWallet?: number[];
  traitsInWalletCount?: number;
  fetchTraitsInWallet: () => void;
};

const AssetsContext = React.createContext<AssetsContextValue>({
  readHoneyBalance: () => {},
  readFancyBearsInWallet: () => {},
  readHoneyJarsInWallet: () => {},
  fetchTraitsInWallet: () => {},
});

export default AssetsContext;
